// extracted by mini-css-extract-plugin
module.exports = {"stepperPrecise":"style_stepperPrecise__3ZGw1","stepperPrecise_currentValue":"style_stepperPrecise_currentValue__2TTJk"};